var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"imageClass"},[_c('img',{attrs:{"src":require("@/assets/img/logo.png")},on:{"click":function($event){return _vm.gotoHomePage()}}})]),_c('div',{staticClass:"routerBox"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:item.pathName,class:{
        routerBoxItem: item.pathName === _vm.$route.name,
        routerBoxItemUnClick: item.pathName !== _vm.$route.name,
        routerLogin: item.pathName == 'login',
      },on:{"click":function($event){return _vm.gotoPage(item, index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }